module.exports = __webpack_public_path__ + "img/rocket-white.5cf6fa32.svg";